"use client"

import type React from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/dialog"

interface AddClassificationDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	editing: { name: string, classification_description: string } | null
	onSave: (classification: { name: string, classification_description: string }) => void
	trigger: React.ReactNode
	className?: string
}

export function EasyAddClassificationDialog({
	open,
	onOpenChange,
	editing,
	onSave,
	trigger,
	className,
}: AddClassificationDialogProps) {

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const formData = new FormData(e.currentTarget)
		const name = formData.get("name") as string
		const classification_description = formData.get("classification_description") as string
		//const classification_prompt = formData.get("classification_prompt") as string


		onSave({
			name,
			classification_description

		})
	}

	return (
		<Dialog open={open} onOpenChange={onOpenChange} >
			<DialogTrigger className={` ${className}`} asChild>{trigger}</DialogTrigger>
			<DialogContent className={`max-w-2xl `}  >
				<form onSubmit={handleSubmit}>
					<DialogHeader>
						<DialogTitle>{editing ? "Edit Classification" : "Add Classification"}</DialogTitle>
						<DialogDescription>
							{editing ? "Update classification details" : "Create a new document classification"}
						</DialogDescription>
					</DialogHeader>
					<div className="space-y-4 py-4">
						<div className="space-y-2">
							<Label htmlFor="name">Classification Name</Label>
							<Input id="name" name="name" defaultValue={editing?.name} placeholder="Referral" required />
						</div>

						<div className="space-y-2">
							<Label htmlFor="classification_description">Describe Classifier</Label>
							<Textarea
								id="classification_description"
								name="classification_description"
								defaultValue={editing?.classification_prompt}
								placeholder="Describe the type of document and the type of data you want"
								rows={4}
							/>
						</div>

					</div>
					<DialogFooter>
						<Button type="submit">{editing ? "Update" : "Create"}</Button>
					</DialogFooter>
				</form>
			</DialogContent>
		</Dialog>
	)
}

